module.exports = __webpack_public_path__ + "img/icon_sns_02.c304f2ff.svg";